import { createAsyncThunk } from '@reduxjs/toolkit';

import { getTruckConsumption } from '../../utils';

export const fetchTruckConsumption = createAsyncThunk(
  'truckConsumption/fetchTruckConsumption',
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const data = await getTruckConsumption(startDate, endDate);

      return data.map(
        ({
          id,
          plate,
          brand,
          factory_consumption,
          liters_sum,
          odo_max,
          odo_min,
        }) => {
          const mileage = odo_max - odo_min;
          const litersPeriod = Number(liters_sum);
          const factoryConsumption = Number(factory_consumption);

          let actualConsumption =
            mileage > 0 ? (litersPeriod * 100) / mileage : 0;
          let diff =
            actualConsumption === 0
              ? null
              : Number((actualConsumption - factoryConsumption).toFixed(2));

          return {
            id: id,
            plate: plate,
            brand: brand,
            mileage: mileage,
            litersPeriod: litersPeriod.toFixed(2),
            actualConsumption: actualConsumption.toFixed(2),
            factoryConsumption: factoryConsumption.toFixed(2),
            diff,
          };
        }
      );
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
